import { initMap, equalCols } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const buyBackLead = {
        isLoading: false,
        init() {
            $(document).on('click', '.buy-back-link', this, this.show);
            $(document).on('click', '.trade-in-link', this, this.show);
            $(document).on('click', '#buy-back-send-btn', this, this.send);

			$(document).on('click', '#buy-back-request .radio-line .form-check', function(){
				$('#buy-back-request .radio-line .form-check').removeClass("selected");
				$('#buy-back-request .radio-line .form-check-input').prop('checked', false);
				$(this).addClass("selected");
				$(this).find(".form-check-input").prop('checked', true);
			});
			$(document).on('change', '#bb_person_type', function(e) {
				if ($(this).is(':checked')) {
					$('#bb-company-wrapper').show();
				} else {
					$('#bb-company-wrapper').hide();
				}

				if ($(document).width() > 1025) {
					equalCols('.buy-back-eq-height');
				}
			});

			const urlParams = new URLSearchParams(window.location.search);
			if (urlParams.get('fbb') === 'true') {
				$('.buy-back-link').trigger('click');
			}

			if ($('.buy-back-form-in-page').length > 0) {
				if ($(document).width() > 1025) {
					equalCols('.buy-back-eq-height');
				}
			}
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

			let dealerId = 1*$(this).data('dealer-id');
			let modelId = 1*$(this).data('model-id');
			let source = $(this).data('source');

			if (_this.isLoading) {
                return false;
            }

			let errors = false;
			$('#buy-back-request').find('.form-control').removeClass('is-invalid');
			$('#buy-back-request').find('.form-check-input').removeClass('is-invalid');
			$('#bb-notifications').html('');

			if($('#bb_person_type').is(':checked')) {
				if ($('#company').val() == '') {
					$('#company').addClass('is-invalid');
					errors = true;
				}
				if ($('#cui').val() == '') {
					$('#cui').addClass('is-invalid');
					errors = true;
				}
			}
			if ($('#salutation option:selected').val() == '') {
				$('#salutation').addClass('is-invalid');
				errors = true;
			}
			if ($('#first_name').val() == '') {
				$('#first_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#last_name').val() == '') {
				$('#last_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#email').val() == '') {
				$('#email').addClass('is-invalid');
				errors = true;
			}
			if ($('#phone').val() == '') {
				$('#phone').addClass('is-invalid');
				errors = true;
			}
			if ($(this).data('type') != 1) {
				if ($('#manufacturer_model_of_interest').val() == '') {
					$('#manufacturer_model_of_interest').addClass('is-invalid');
					errors = true;
				}
			}
			if ($('#bb_manufacturer').val() == '') {
				$('#bb_manufacturer').addClass('is-invalid');
				errors = true;
			}
			if ($('#bb_model').val() == '') {
				$('#bb_model').addClass('is-invalid');
				errors = true;
			}
			if ($('#bb_vin').val() == '') {
				$('#bb_vin').addClass('is-invalid');
				errors = true;
			}
			if ($('#registration_year').val() == '') {
				$('#registration_year').addClass('is-invalid');
				errors = true;
			}
			if ($('#odometer').val() == '') {
				$('#odometer').addClass('is-invalid');
				errors = true;
			}
			if ($('#motorization').val() == '') {
				$('#motorization').addClass('is-invalid');
				errors = true;
			}
			if ($('#features').val() == '') {
				$('#features').addClass('is-invalid');
				errors = true;
			}
			if (!$('#buy-back-terms-and-condition').is(":checked")) {
				$('#buy-back-terms-and-condition').addClass('is-invalid');
				errors = true;
			}

			if (errors) {
				$('#bb-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
				document.getElementById('buy-back-request').scrollTop = 0;
				return false;
			}

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values = 'salutation=' + $('#salutation option:selected').val();
			values += '&person_type=' + ($('#bb_person_type').is(':checked')?1:0);
			values += '&company=' + $('#company').val();
			values += '&cui=' + $('#cui').val();
			values += '&first_name=' + $('#first_name').val();
			values += '&last_name=' + $('#last_name').val();
			values += '&email=' + $('#email').val();
			values += '&phone=' + $('#phone').val();
			values += '&manufacturer_model_of_interest=' + $('#manufacturer_model_of_interest').val();
			values += '&manufacturer=' + $('#bb_manufacturer').val();
			values += '&model=' + $('#bb_model').val();
			values += '&vin=' + $('#bb_vin').val();
			values += '&registration_year=' + $('#registration_year').val();
			values += '&odometer=' + $('#odometer').val();
			values += '&motorization=' + $('#motorization').val();
			values += '&features=' + $('#features').val();
			values += '&type=' + $(this).data('type');
			values += '&newsletter=' + ($('.buy-back-newsletter:checked').val()?$('.buy-back-newsletter:checked').val():0);
			values += '&_token=' + $('#_token_bb').val();
			$.ajax({
				type: "POST",
				url: buyBackRoutePost,
				data: values,
				success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#' + errorKey).addClass('is-invalid');
                                //errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
						$('#bb-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
                        return false;
                    }

					if (response.status == 1) {

						if (source == 'page') {
							$('#buy-back-request').find('.form-control').val('');
							$('#buy-back-request').find('.form-check-input').prop('checked', false);
						}

						$('#buy-back-request').modal('hide');
						$('#buy-back-request').on('hidden.bs.modal', function() {
							$('#buy-back-container').html('');
						});

						Swal.fire({
							icon: 'success',
							title: 'Success!',
							html: formSuccessMessage
						});

						if (cookies_advertisement == 1 || cookies_social == 1) {
							fbq('track', 'Lead');
						}

						return false;
					}

					$('#bb-notifications').html('<div class="alert alert-danger" role="alert">'+response.message+'</div>');
				},
				error(error) {
					_this.isLoading = false;
					$(element).find('i').hide();
				},
			});
		},
		show(event) {
			const _this = event.data;
			event.preventDefault();

			if (_this.isLoading) {
                return false;
            }

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').removeClass('fa-steering-wheel').addClass('fa-spinner fa-spin');

			$.ajax({
	            type: "GET",
	            url: buyBackRoute + '?type=' + $(this).data('type'),
	            data: '',
	            success: function(response) {
					//check if full menu is open, if is close it
					// if ($('.meniu-desktop').hasClass('open')) {
					// 	$('.meniu-desktop').removeClass('open');
					// }
					$(".header").removeClass('mobile-meniu-open');

					$('#buy-back-container').html(response);
					$('#buy-back-request').modal('show');

					$('#buy-back-request').on('shown.bs.modal', function (e) {
						if ($(document).width() > 1025) {
							equalCols('.buy-back-eq-height');
						}
					});

					_this.isLoading = false;
					$(element).find('i').removeClass('fa-spinner fa-spin').addClass('fa-steering-wheel');
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').removeClass('fa-spinner fa-spin').addClass('fa-steering-wheel');
                },
	        });
		}
    };

    if ($('.buy-back-link').length > 0 || 
		$('.trade-in-link').length > 0 || 
		$('.buy-back-form-in-page').length > 0) {
        buyBackLead.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/buy-back-lead.js